/**
 * author: lingyb
 */
export * from './select.module';
export * from './select.component';
